import React from "react";
import { Route, Routes } from "react-router-dom";
import ShoppingPage from "../ShoppingPage";
import WorkExchangePage from "../WorkExchangePage";

const ArtDesignPage = () => {
  return (
    <Routes>
      <Route
        path="community-spaces/*"
        element={<ShoppingPage isParanoma={true} />}
      />
      <Route path="work-exchanges/*" element={<WorkExchangePage />} />
    </Routes>
  );
};

ArtDesignPage.propTypes = {};

export default ArtDesignPage;
